<template>
  <img
    v-if="logoUrl"
    class="merchant-logo max-xl:max-h-12!"
    :src="logoUrl"
    :alt="locale.group ?? 'merchant logo'"
  />
</template>

<script setup lang="ts">
  import { useMerchantLogoAsset } from "@/assets"
  import { useLocaleStore, useMerchantStore } from "@versatile-credit-apply/sdk"
  import { computed } from "vue"

  const store = useMerchantStore()
  const locale = useLocaleStore()

  const logo = useMerchantLogoAsset(() => locale.group)
  const versatileLogo = useMerchantLogoAsset(() => "versatile")
  const logoUrl = computed(
    () => store.logoConfig?.url ?? logo.value ?? versatileLogo.value
  )

  // Defaults of 70% and auto are set for the versatile logo
  const logoWidth = computed(() => store.logoConfig?.maxWidth ?? "70%")
  const logoHeight = computed(() => store.logoConfig?.maxHeight ?? "auto")
</script>

<style scoped>
  .merchant-logo {
    max-width: v-bind(logoWidth);
    max-height: v-bind(logoHeight);
  }
</style>
